import { PrinterConfig } from "./types";
import { isNativePlatform } from "@/utils/native";

export type BrowserPrintData =
  | { type: "browser-pdf"; pdfBase64: string }
  | { type: "browser-html"; html: string };

const A4_MARGIN_MM = 10;
const A4_CONTENT_MAX_WIDTH_MM = 120;

export function isA4Printer(printerConfig: PrinterConfig): boolean {
  return printerConfig?.printerType === "a4";
}

// The mobile app prints on the device's own receipt printer, never the
// location's printer.
export function shouldPrintInvoiceAsPdf(printerConfig: PrinterConfig): boolean {
  return !isNativePlatform() && isA4Printer(printerConfig);
}

export function createPdfPrintData(pdfBase64: string): BrowserPrintData {
  return { type: "browser-pdf", pdfBase64 };
}

export function createA4HtmlPrintData(
  receiptHtml: string,
  fontSizePx: number,
): BrowserPrintData {
  return {
    type: "browser-html",
    html: `<!doctype html><html><head><meta charset="utf-8"><style>@page { size: A4; margin: ${A4_MARGIN_MM}mm; } body { margin: 0; font-family: sans-serif; }</style></head><body><div style="font-size: ${fontSizePx}px; max-width: ${A4_CONTENT_MAX_WIDTH_MM}mm; margin: 0 auto;">${receiptHtml}</div></body></html>`,
  };
}

export function isBrowserPrintData(printData: {
  type: string;
}): printData is BrowserPrintData {
  return printData.type === "browser-pdf" || printData.type === "browser-html";
}
